import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  _setResponseListForm,
  excelDownLoad,
  reDirectPage,
  setMultipartForm,
  setRequestForm,
} from '../../../lib/common';
import toastMsg from '../../../lib/toastMsg';
import { pointActions } from './index';
import PointApi from '../../../lib/api/point/PointApi';
import pointToastMsg from '../../../constants/service/toastMsg/pointToastMsg';
import appActions from '../app/actions';
import { POINT_CAUSE_LIST_URL_PATH } from '../../../constants/service/common/urlConstants';

function* fetchList() {
  /**
   *  [포인트 내역 리스트] 포인트 내역 리스트 요청하기
   */
  yield takeEvery(pointActions.GET_POINT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPointList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_POINT_LIST_REQUEST_SUCCESS);

        const data = {
          pointList: _setResponseListForm(result.data.pointLogList, result.data.totalCnt, payload),
          adminSelectList: result.data.adminSelectList,
          pointCauseSelectList: result.data.pointCauseSelectList,
        };

        yield put({ type: pointActions.GET_POINT_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_POINT_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [포인트 랭킹] 포인트 랭킹 요청하기
   */
  yield takeEvery(pointActions.GET_POINT_RANKING_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPointRanking, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_POINT_RANKING_REQUEST_SUCCESS);

        const data = {
          pointRanking: _setResponseListForm(result.data.pointRanking, result.data.totalCnt, payload),
        };
        yield put({ type: pointActions.GET_POINT_RANKING_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_POINT_RANKING_REQUEST_ERROR);
    }
  });

  /**
   * [포인트 log 모달] 포인트 log 요청하기
   */
  yield takeEvery(pointActions.GET_POINT_LOG_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPointLog, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_POINT_LOG_REQUEST_SUCCESS);

        const data = {
          pointLog: _setResponseListForm(result.data.pointLog, result.data.totalCnt, payload),
        };
        yield put({ type: pointActions.GET_POINT_LOG_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_POINT_LOG_REQUEST_ERROR);
    }
  });

  /**
   * [포인트 발급] 쿠폰 발급받을 유저 리스트 요청하기
   */
  yield takeEvery(pointActions.GET_GENERATE_POINT_USER_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getGenerateSearchUserList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_GENERATE_POINT_USER_LIST_REQUEST_SUCCESS);

        const data = {
          userList: _setResponseListForm(result.data.userList, result.data.totalCnt, payload),
        };

        yield put({ type: pointActions.GET_GENERATE_POINT_USER_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_GENERATE_POINT_USER_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   * [포인트 발급] 포인트 발급 전 준비 데이터 받아오기
   */
  yield takeEvery(pointActions.GET_PREPARATION_GENERATE_POINT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPreparationGeneratePoint, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_PREPARATION_GENERATE_POINT_REQUEST_SUCCESS);

        const data = {
          pointCauseSelectList: result.data.pointCauseSelectList,
        };

        yield put({ type: pointActions.GET_PREPARATION_GENERATE_POINT_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_PREPARATION_GENERATE_POINT_REQUEST_ERROR, error);
    }
  });

  /**
   *  [포인트 일괄 발급] 엑셀 일괄 발급 유효성 체크요청하기
   */
  yield takeEvery(pointActions.EXCEL_BULK_GENERATE_POINT_CHECK_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.excelBulkGeneratePointCheck, setMultipartForm(payload, true));

      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.EXCEL_BULK_GENERATE_POINT_CHECK_REQUEST_SUCCESS);

        const { userPointList, pointCauseSelectList, requestCnt, possibleCnt, impossibleCnt, isBulk } = result.data;

        /**
         * 실패건이 하나라도 있는 경우에는 실패 모달로 보낸다.
         */
        if (impossibleCnt > 0) {
          /**
           *  포인트 발급 유효 체크 실패 모달 띄우기
           */
          yield put(
            appActions.appToggleModal({
              name: 'generatePointValidFailModal',
              value: true,
              data: {
                userPointList,
                pointCauseSelectList,
                requestCnt,
                possibleCnt,
                impossibleCnt,
                isBulk,
              },
            }),
          );
        } else {
          /**
           *  포인트 발급 유효 체크 성공 모달 띄우기
           */
          yield put(
            appActions.appToggleModal({
              name: 'generatePointValidSuccessModal',
              value: true,
              data: {
                userPointList,
                pointCauseSelectList,
                requestCnt,
                possibleCnt,
                impossibleCnt,
                targetAction: payload.targetAction,
              },
            }),
          );
        }
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.EXCEL_BULK_GENERATE_POINT_CHECK_REQUEST_ERROR);
    }
  });

  /**
   *  [포인트 발급] 포인트 발급받을 유저 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(pointActions.GET_GENERATE_POINT_USER_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getGenerateUserListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GENERATE_POINT_USER_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('포인트 발급받을 유저 리스트', result.data.pointGenerateUserListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || pointToastMsg.GENERATE_POINT_USER_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [포인트 랭킹] 포인트 랭킹 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(pointActions.GET_POINT_RANKING_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPointRankingListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_POINT_RANKING_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('포인트 랭킹 리스트', result.data.pointRankingListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || pointToastMsg.GET_POINT_RANKING_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [포인트 발급 내역 리스트] 포인트 발급 내역 리스트 가져오기
   */
  yield takeEvery(pointActions.GET_POINT_ISSUE_HISTORY_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPointIssueHistoryList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_POINT_ISSUE_HISTORY_LIST_REQUEST_SUCCESS);

        const data = {
          pointIssueHistoryList: _setResponseListForm(result.data.pointIssueHistoryList, result.data.totalCnt, payload),
          adminSelectList: result.data.adminSelectList,
        };

        yield put({ type: pointActions.GET_POINT_ISSUE_HISTORY_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_POINT_ISSUE_HISTORY_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [포인트 발급 내역 상세] 포인트 발급 내역 상세 가져오기
   */
  yield takeEvery(pointActions.GET_POINT_ISSUE_HISTORY_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPointIssueHistoryDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_POINT_ISSUE_HISTORY_DETAIL_REQUEST_SUCCESS);

        const data = {
          pointIssueHistoryDetail: {
            pointIssueHistoryInfo: result.data.pointIssueHistoryInfo,
            pointIssueHistoryItemList: _setResponseListForm(
              result.data.pointIssueHistoryItemList,
              result.data.totalCnt,
              payload,
            ),
          },
          pointCauseSelectList: result.data.pointCauseSelectList,
        };

        yield put({ type: pointActions.GET_POINT_ISSUE_HISTORY_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_POINT_ISSUE_HISTORY_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   *  [포인트 발급 내역 상세] 포인트 발급 로그 가져오기
   */
  yield takeEvery(pointActions.GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPointLogList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_REQUEST_SUCCESS);

        const data = {
          pointIssueHistoryDetail: {
            pointIssueHistoryItemList: _setResponseListForm(result.data.pointLogList, result.data.totalCnt, payload),
          },
        };

        yield put({ type: pointActions.GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [레퍼럴 발급 현황] 레퍼럴 발급 리스트 가져오기
   */
  yield takeEvery(pointActions.GET_POINT_REFERRAL_ISSUE_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPointReferralIssueList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_POINT_REFERRAL_ISSUE_LIST_REQUEST_SUCCESS);

        const data = {
          pointReferralIssueList: _setResponseListForm(
            result.data.pointReferralIssueList,
            result.data.totalCnt,
            payload,
          ),
        };

        yield put({ type: pointActions.GET_POINT_REFERRAL_ISSUE_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_POINT_REFERRAL_ISSUE_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [포인트 사유 리스트] 포인트 사유 리스트 가져오기
   */
  yield takeEvery(pointActions.GET_POINT_CAUSE_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.getPointCauseList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.GET_POINT_CAUSE_LIST_REQUEST_SUCCESS);

        const data = {
          pointCauseList: _setResponseListForm(result.data.pointCauseList, result.data.totalCnt, payload),
        };

        yield put({ type: pointActions.GET_POINT_CAUSE_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.GET_POINT_CAUSE_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [포인트 사유 등록] 포인트 사유 등록하기
   */
  yield takeEvery(pointActions.CREATE_POINT_CAUSE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(PointApi.createPointCause, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(pointToastMsg.CREATE_POINT_CAUSE_REQUEST_SUCCESS);

        reDirectPage({ path: POINT_CAUSE_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(pointToastMsg.CREATE_POINT_CAUSE_REQUEST_ERROR);
    }
  });
}

export default function* pointSaga() {
  yield fork(fetchList);
}
